import { createContext, Dispatch, SetStateAction } from "react";

export const SignalActionsContext = createContext<
  | {
      selectedSignalIDs: number[];
      setSelectedSignalIDs: Dispatch<SetStateAction<number[]>>;
      isBulkMode: boolean;
      setIsBulkMode: Dispatch<SetStateAction<boolean>>;
      bulkCloseSignalsModalOpen: boolean;
      setBulkCloseSignalsModalOpen: Dispatch<SetStateAction<boolean>>;
      actionButtonsData: { text: string; onClick: () => void }[];
      exitBulkMode: () => void;
      selectAll: (ids: number[]) => void;
      signalIDs: number[];
      showEditSignalActions: boolean;
    }
  | undefined
>(undefined);
